<template>
  <div>
    <b-card no-body>
      <template v-slot:header>
        <div class="text-center">
          <h6 class="surtitle">Listings</h6>
          <h4 class="mb-0">Held</h4>
          <h5 class="mb-0" v-if="listingStats">Gap: {{ gap }}</h5>
        </div>
      </template>
      <div class="px-2">
        <div class="chart-area">
          <doughnut-chart
            :height="210"
            :chart-data="stats.chartData"
            :extra-options="stats.extraOptions"
          >
          </doughnut-chart>
        </div>
        <div id="chart-info" class="text-center" v-if="listingStats">
          <div class="top-number">{{ listingStats.listings_held }}</div>
          <div class="bottom-number">{{ listingStats.estimated_appt_held.toFixed() }}</div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import DoughnutChart from '@/components/Charts/DoughnutChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from "@/components/Charts/config";

export default {
  props: {
    listingStats: null
  },
  components: {
    DoughnutChart
  },
  data() {
    return {
      stats: {
        chartData: {
          labels: [
            'Listings Held',
            'Listings Held Left'
          ],
          datasets: [{
            data: [
              this.listingStats.listings_held,
              this.listingStats.estimated_appt_held.toFixed() - this.listingStats.listings_held > 0 ? this.listingStats.estimated_appt_held.toFixed() - this.listingStats.listings_held : 0
            ],
            backgroundColor: [
              Charts.colors.theme['success'],
              Charts.colors.theme['secondary'],
            ],
            label: 'Listings Held'
          }],
        },
        extraOptions: {
          responsive: true,
          legend: {
            position: 'top',
          },
          animation: {
            animateScale: true,
            animateRotate: true
          }
        }
      }
    }
  },
  computed: {
    gap() {
      let listingsHeld = this.listingStats.estimated_appt_held.toFixed() - this.listingStats.listings_held;

      return listingsHeld > 0 ? listingsHeld : 0;
    }
  }
};
</script>
<style lang="scss">
#chart-info {
  position: absolute;
  top: 50%;
  bottom: 50%;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;

  .top-number, .bottom-number {
    font-size: 20px;
    font-weight: bold;
  }

  .top-number {
    margin-bottom: 5px;
  }

  .bottom-number {
    margin-top: 5px;
  }
}
</style>